import { Input, InputGroup, InputRightElement } from "@chakra-ui/react";
import { ReactNode } from "react";

interface InputProps {
  inputRightElement?: ReactNode;
  value: string;
  error?: string;
  //   isDisabled?: boolean;
  //   maxFractionDigits: number;
  onChange?: (val: string) => void;
  disabled?: boolean;
}

const TicketInput = ({
  inputRightElement,
  value,
  onChange,
  error,
  disabled = false,
}: InputProps) => {
  return (
    <InputGroup size="lg" mt="12px">
      <Input
        type="text"
        variant="unstyled"
        placeholder="0.0"
        borderRadius="1rem"
        bg="backgroundField"
        border="1px solid"
        p="24px"
        h="96px"
        color="textPrimary"
        fontWeight="700"
        fontSize="32px"
        lineHeight="38px"
        value={value}
        isInvalid={!!error}
        onChange={(e) => onChange?.(e.target.value)}
        borderColor={error ? "error" : "backgroundDivider"}
        _placeholder={{
          color: "textTertiary",
        }}
        disabled={disabled}
      />

      {inputRightElement && (
        <InputRightElement my="auto" h="100%" mr="1.5rem" w="auto">
          {inputRightElement}
        </InputRightElement>
      )}
    </InputGroup>
  );
};

export default TicketInput;
